'use client';

import { useAuthStore, useLogout } from '@/modules/authentication/application';
import { Navbar } from '@/modules/navigation/presentation/composites';

import { useToast } from '@packages/web-design-systems';

export const NavbarContainer = () => {
	const { isAuthenticated } = useAuthStore();
	const { execute } = useLogout();
	const { showSuccess } = useToast();

	const handleLogout = async () => {
		await execute();
		showSuccess({ title: 'Logout successful' });
	};

	return <Navbar isAuthenticated={isAuthenticated} onClickLogout={handleLogout} />;
};
